import AxiosInstance from "../instance";
import {BACKEND_URI} from "../../utils/Constants";
import AwesomeDebouncePromise from "awesome-debounce-promise";

export interface IStock {
    company_name: string;
    stock_exchange: string;
    ticker: string;
}

const parseResponse = <T>(response: { data: T }): T => response.data;

const searchStocksByTickerOrig = async (ticker: string): Promise<IStock> => {
    const response = await AxiosInstance.getInstance()
        .get(BACKEND_URI+ '/stocks', {
            params: {
                query: ticker
            }
        });
    return parseResponse(response);
};

const searchStocksByTicker = AwesomeDebouncePromise(
    searchStocksByTickerOrig,
    500
);

const getHedgingOutput = async (ticker: string, exchange: string) => {
    const response = await AxiosInstance.getInstance().get("/hedging", {
        params: {
            exchange_ticker: exchange + "-" + ticker
        }
    });
    return response;
};

export {getHedgingOutput, searchStocksByTicker};


// WEBPACK FOOTER //
// ./src/api/models/Hedging.ts